import { useEffect, useState } from 'react';

type Props = {
  message: string;
  onDone: () => void;
  durationMs?: number;
};

export function Toast({ message, onDone, durationMs = 1500 }: Props): JSX.Element {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const t = window.setTimeout(() => {
      setVisible(false);
      window.setTimeout(onDone, 200);
    }, durationMs);
    return () => clearTimeout(t);
  }, [durationMs, onDone]);
  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 bottom-[max(80px,env(safe-area-inset-bottom))] bg-primary text-canvas rounded-full px-5 py-2 text-hint shadow-lg transition-opacity"
      style={{ opacity: visible ? 1 : 0 }}
    >
      {message}
    </div>
  );
}
